import styled from '@emotion/styled'

import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import DiagnoseDataQualityIssuesImage from './DiagnoseDataQualityIssuesImage'

const copy = {
  heading: `Diagnose data quality issues`,
}

const features = [
  {
    heading: `Automate the QA process`,
    description: `Manually testing your tracking code is time consuming and doesn’t always catch every incorrect property or data type. With automatic Data Validation, you can audit your implementation in minutes.`,
  },
  {
    heading: `Have confidence making decisions with clean data`,
    description: `Most companies detect issues after their team has used bad data to make decisions or trigger campaigns. Quickly take action on every invalid event with in-app reporting and daily email digests.`,
  },
]

export const DiagnoseDataQualityIssues = () => {
  return (
    <Wrapper>
      <SectionComponent variant="2Col" copyVariant="narrow">
        <StyledSectionCopy>
          <CopyTextBase>
            <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          </CopyTextBase>
          <ColumnTrackWrapper>
            <ColumnTrack>
              {features.map((feature) => (
                <FeatureBoxBase key={feature.heading} alignment="left">
                  <FeatureBox.Body>
                    <FeatureBox.Title>{feature.heading}</FeatureBox.Title>
                    <FeatureBox.Text>{feature.description} </FeatureBox.Text>
                  </FeatureBox.Body>
                </FeatureBoxBase>
              ))}
            </ColumnTrack>
          </ColumnTrackWrapper>
        </StyledSectionCopy>
        <Section.Contents>
          <DiagnoseDataQualityIssuesImage />
        </Section.Contents>
      </SectionComponent>
    </Wrapper>
  )
}

const StyledSectionCopy = styled(Section.Copy)`
  max-width: 440px;
`

const SectionComponent = styled(SectionBase)`
  overflow-x: visible;
  justify-content: center;
`

const ColumnTrackWrapper = styled.div`
  margin-top: 40px;
`
const Wrapper = styled.section`
  ${({ theme }) => theme.breakpoints.up(`md`)} {
    padding-bottom: 40px;
  }
`

export default DiagnoseDataQualityIssues
